import { Component, Injector, OnInit } from "@angular/core";
import { TableAbstractComponent } from "src/app/common-page-components/classes/table-abstract-component";
import { AthleteWcupRankingFiltersService } from "../../services/athlete-wcup-ranking-filters.service";
import {
  AthleteWCupPageStore,
  IWCupAthleteDetail,
  IWCupAthleteIndividual,
  IWCupAthleteItem,
} from "src/app/common-page-components/stores/entities-store/world-cup-athlete.store";
import { HttpClient } from "@angular/common/http";
import { FiltersAthleteGeneralService } from "src/app/athlete/services/filters-athlete-general.service";
import { filter, find, map, mergeMap, tap } from "rxjs/operators";
import { AthleteCategoriesCombo } from "src/app/common-page-components/stores/filters-store/filters-store";
import { BehaviorSubject, combineLatest, forkJoin, Observable, of } from "rxjs";
import { SeriesStageIndoorStore } from "src/app/common-page-components/stores/entities-store/series-stage-indoor-store";
import { SeriesStageLocator } from "world-archery-lib";
import { AthleteWcupRankingFiltersFinalsService } from "../../services/athlete-wcup-ranking-filters-finals.service";
import { AthleteWcupRankingFiltersStageService } from "../../services/athlete-wcup-ranking-filters-stage.service";
import { FiltersAbstractService } from "src/app/common-page-components/classes/filters-abstract-service";


export class WCupInsightsDto {
  appearances = 0;
  podiums = 0;
  wins = 0;
}

export class WCupTableResultsDto {
  public results = [];
  public insights = new WCupInsightsDto();
}


@Component({
  selector: "app-bootstrap-athlete-wcup-ranking",
  templateUrl: "./bootstrap-athlete-wcup-ranking.component.html",
  styleUrls: ["./bootstrap-athlete-wcup-ranking.component.scss"],
})
export class BootstrapAthleteWcupRankingComponent
  extends TableAbstractComponent
  implements OnInit {
  /**
   * The insights view on the first view of page that must be computed due to filtering.
   *
   * @type {{appearances: number, podiums:number, circuit_titles:number}}
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  insights: { appearances: number; podiums: number; circuit_titles: number };

  /**
   * The object to present results data sortered by stage on the first table.
   *
   * @type Array<{{Year:number, Stage_1:IWCupAthleteIndividual, Stage_2:IWCupAthleteIndividual, Stage_3:IWCupAthleteIndividual, Final:IWCupAthleteIndividual}}>
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  resultsDataProcess: Array<{
    Year: number;
    Stage_1: IWCupAthleteIndividual;
    Stage_2: IWCupAthleteIndividual;
    Stage_3: IWCupAthleteIndividual;
    Final: IWCupAthleteIndividual;
  }> = [];

  /**
   * The observable to set the next target and perform data splitting in different tables.
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  $resultsDataProcess: BehaviorSubject<any> = new BehaviorSubject([]);

  /**
   * The observable to set the next target and perform data splitting in different tables.
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  $resultsGeneralProcess: BehaviorSubject<any> = new BehaviorSubject([]);

  /**
   * The observable to set the next target and perform data splitting in different tables.
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  $resultsGeneralProcessData: BehaviorSubject<any> = new BehaviorSubject(undefined);

  /**
   * The results of the stage table on medium of page.
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  $resultsStage: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  $insightsStage: BehaviorSubject<WCupInsightsDto> = new BehaviorSubject(new WCupInsightsDto());

  /**
   * The results of the final table on end of page.
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  $resultsFinal: BehaviorSubject<Array<any>> = new BehaviorSubject([]);

  $insightsFinal: BehaviorSubject<WCupInsightsDto> = new BehaviorSubject(new WCupInsightsDto());

  /**
   * A store reference to series Stage indoor to get stage data.
   *
   * @type {SeriesStageIndoorStore}
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  seriesStageStore: SeriesStageIndoorStore;
  /**
   * {@inheritdoc}
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  constructor(
    public common_service: FiltersAthleteGeneralService,
    public wcup_athlete_service: AthleteWcupRankingFiltersService,
    public wcup_athlete_finals_service: AthleteWcupRankingFiltersFinalsService,
    public wcup_athlete_stage_service: AthleteWcupRankingFiltersStageService,
    injector: Injector
  ) {
    super(
      injector,
      wcup_athlete_service,
      new AthleteWCupPageStore(injector.get(HttpClient), injector)
    );
    this.seriesStageStore = new SeriesStageIndoorStore(injector);
  }

  computeInsights(data: IWCupAthleteItem[]) {
    // In insights section:

    // Appearances number is total number of “Caps” combined in sublevel ID 12 and sublevel ID 13.
    const appearances: number = data
      .filter((a) => a.SubLevelId == 12 || a.SubLevelId == 13)
      .map((f) => f.Caps)
      .reduce((f, s) => f + s, 0);
    // Podiums number is total number of “podiums” combined sub ID12 + 13
    const podiums: number = data
      .filter((a) => a.SubLevelId == 12 || a.SubLevelId == 13)
      .map((f) => f.Podiums)
      .reduce((f, s) => f + s, 0);
    // Circuit titles is number of individual rnk:1 in sublevel ID 13. ONLY
    const circuit_titles: number = (
      [].concat.apply(
        [],
        data.filter((a) => a.SubLevelId == 13).map((f) => f.Details)
      ) as IWCupAthleteDetail[]
    )
      .filter((detail) => detail.Individual.length > 0)
      .map((detail) => detail.Individual)
      .flat().filter((detail) => detail.Rnk === 1).length
    return {
      appearances: appearances,
      podiums: podiums,
      circuit_titles: circuit_titles,
    };
  }



  eventCatCodeMatchesCatCode(eventType: string, itemCatCode, catCode: string): boolean {
    if (eventType !== "Mixed") {
      return itemCatCode == catCode;
    }
    // Extract the last character (gender) from the catCode
    const gender = catCode.charAt(catCode.length - 1);
    // Create the expected catCode for "Mixed" events by replacing "X" with the gender
    const expectedCatCode = catCode.replace(gender, "X");
    // Compare the expected catCode with the catCode from resultData
    return itemCatCode === expectedCatCode;
  }

  /**
   * Process athlete data in events and prepares it for displaying.
   *
   * Tasks:
   *   - Filter out items that don't match current filters
   *   - Collects insights.
   *
   * @param resultSet
   * @param eventType
   * @param podiumsOnly
   * @param catCode
   * @returns
   */
  prepareResults(resultSet, eventType, podiumsOnly, catCode) {

    const acc = new WCupTableResultsDto();

    let appearancesBucket = {};

    resultSet.reduce((acc: WCupTableResultsDto, item) => {
      // Filter elements that are no used by the insights, so filter everything
      // that has not the selected event type and category.
      const eventMatches = eventType.toUpperCase() === 'ALL' || item.Event === eventType;
      const catMatches = this.eventCatCodeMatchesCatCode(eventType, item.Results.CatCode, catCode);

      // Ignore item if cat or event doesn't match.
      if (!eventMatches || !catMatches) {
        return acc;
      }

      // Here we can calculate the insights because we only have the items
      // selected by the filters, with the exception of "podium" filter. This
      // is because the insights don't take into account the podium filter.

      // For appearance we use a "bucket" to know all the competitions. Later
      // we'll count how many we collect. WE use a dictionary so the same
      // competition ID doesn't generate a new entry in the dictionary.
      appearancesBucket[item.ID] = true;
      acc.insights.podiums = item["Results"].Rnk < 4 ? acc.insights.podiums + 1 : acc.insights.podiums;
      acc.insights.wins = item["Results"].Rnk === 1 ? acc.insights.wins + 1 : acc.insights.wins;

      // Add item depending on the podium filter,
      if (!podiumsOnly || item.Results.Rnk < 4) {
        acc.results.push(item);
      }

      return acc;
    }, acc);

    // Count all the appearances.
    acc.insights.appearances = Object.keys(appearancesBucket).length;
    return acc;
  }

  /**
   * Subscription functions!
   *
   * Previoulsy, on ngOnInit this component created streams and subscribed to
   * them. This created a 156 cyclomatic complexity function. This is too high.
   * On the ongoing refactor efforts the four created subscriptions have been
   * placed on different functions, so they are easier to refactor in the next
   * steps.
   *
   */


  /**
   * Subs fun 1. See comment above (search for "Subscription functions!")
   * @returns
   */
  getSubscription1() {
    return combineLatest([


      this.common_service.storedId
        .asObservable()
        .pipe(filter((a) => a != undefined)),
      this.wcup_athlete_service.getDataStreamWithFilters(),
      this.$resultsGeneralProcess.asObservable(),
    ]).pipe(map(([id, filters, data]) => {
      const catCode = filters[0].Cat;
      const eventType =
        filters[1].Name === "Mixed Team" ? "Mixed" : filters[1].Name;
      // Convert to string and parse to get a full copy of object.
      const dataToFilter = JSON.parse(JSON.stringify(Array.from(data)));

      this.$resultsGeneralProcessData.next(dataToFilter);
    }))
      .subscribe(next => {

      });

  }
  /**
   * Wires up the observables to get the data for result table.
   *
   * This has been extracted for a longer code so the purpose is not totally
   * clear.
   *
   * @param subLevelId
   * @param resultsSubjectBehavior
   * @param insightsSubjectBehavior
   * @returns
   */
  wireUpWCupSublevelTableData(subLevelId: number,
    filterSrv: FiltersAbstractService,
    resultsSubjectBehavior: BehaviorSubject<any[]>,
    insightsSubjectBehavior: BehaviorSubject<WCupInsightsDto>) {

    return combineLatest([
      this.common_service.storedId
        .asObservable()
        .pipe(filter((a) => a != undefined)),
      filterSrv.getDataStreamWithFilters(),
      this.$resultsDataProcess.asObservable(),
    ])
      .pipe(
        map(([id, filters, data]) => {

          const catCode = filters[0].Cat;
          let eventType =
            filters[1].Name === "Mixed Team" ? "Mixed" : filters[1].Name;
          const podiumsOnly = filters[2].Value;
          const dataToFilter = Array.from(data).filter(
            (value) => (value as any).SubLevelId === subLevelId
          );

          let dataFiltered = [];
          let preparedResults = new WCupTableResultsDto();

          if (dataToFilter.length > 0) {
            dataFiltered = Array.from(dataToFilter);
            dataFiltered.forEach((result) => {
              if (result["ResultsTransformed"]) {
                preparedResults = this.prepareResults(result["ResultsTransformed"], eventType, podiumsOnly, catCode);
              }
            });
          }

          resultsSubjectBehavior.next(preparedResults.results);
          insightsSubjectBehavior.next(preparedResults.insights);
        })
      )
      .subscribe((next) => { });
  }


  /**
   * Adds event data to stage data.
   *
   * This function is part of the effort ti reduce complexity. A code that was
   * repeated has been extracted to this function. No more description because
   * the original code intention is not totally clear.
   *
   * @param stageData
   * @param result
   * @param event
   * @param flag For unknown reasons Final stage is handled a little bit
   * different. This flag instruct the function to use the special case for
   * Final.
   */
  addEventToStageData(stageData, result, event, flag = false) {
    if (
      stageData instanceof Array
    ) {
      stageData.push(
        Object.assign(
          { Event: event },
          result
        )
      );
    }
    else if (flag) {
      stageData.Final = result;
    }
  }
  /**
   * Subs fun 4. See comment above (search for "Subscription functions!")
   * @returns
   */
  getSubscription4() {
    return combineLatest([
      this.common_service.storedId
        .asObservable()
        .pipe(filter((a) => a != undefined)),
    ])
      .pipe(
        mergeMap(([id]) => {
          return this.model.requestData({ Id: id }, false);
        }),
        map((a) => {
          this.insights = this.computeInsights(a.items);
          return a;
        }),
        mergeMap((a) => {
          return combineLatest(
            of(a)
          );
        }),
        mergeMap(([a]) => {
          // This is the country dependency.
          const countryData = this.model.dependencies[0].entity.data;
          (a.items as IWCupAthleteItem[]).forEach((value) => {
            // Get each row and transform them to flat to show all data in tables.
            value["ResultsTransformed_1"] = [].concat
              .apply(
                [],
                (value.Details as IWCupAthleteDetail[]).map((detail) => {
                  return Object.keys(detail.Events).map((event) => {
                    return {
                      Categories: detail.Events[event],
                      ID: detail.ID,
                      Event: event,
                      Place: detail.Place,
                      Year: detail.Year,
                      Results:
                        // Now this object is an Array instead of an object with multiple categories.
                        detail[event] != undefined ? detail[event] : [],
                    };
                  });
                })
              )
              .filter(
                (detailTransformed) =>
                  Object.keys(detailTransformed.Results).length > 0
              );
            const resultsTransformed = [];
            // Iterate over the first results.
            value["ResultsTransformed_1"].forEach(result => {

              // Search for each result in category
              result.Results.forEach(resultOnCategoryPresent => {
                const copyResult = Object.assign({}, result)
                resultsTransformed.push(Object.assign(copyResult, { 'Results': resultOnCategoryPresent }))
              })
            });
            value['ResultsTransformed'] = resultsTransformed;
          });

          const categoriesResultsGeneralTable = [].concat
            .apply(
              [], a.items.map((value => value['ResultsTransformed'])))
            .map((event) => { return { CatCode: event.Results.CatCode, Event: event.Event } });
          const categoriesResultsGeneralTableMixedToNormal =
            categoriesResultsGeneralTable.map((cat) =>
              cat.CatCode.replace("X", "M").replace("X", "W")
            );
          // Map categories to filter them and set the results.
          const categoriesOnResultsSubLevel12 = [].concat
            .apply(
              [], (Array.from(a.items) as Array<any>).filter(value => value.SubLevelId == 12)
                .map((value => value['ResultsTransformed'])))
            .map((event) => { return { CatCode: event.Results.CatCode, Event: event.Event } });
          const categoriesFromMixedToNormalSubLevel12 =
            categoriesOnResultsSubLevel12.map((cat) =>
              cat.CatCode.replace("X", "M").replace("X", "W")
            );
          const categoriesOnResultsSubLevel13 = [].concat
            .apply(
              [], (Array.from(a.items) as Array<any>).filter(value => value.SubLevelId == 13)
                .map((value => value['ResultsTransformed'])))
            .map((event) => { return { CatCode: event.Results.CatCode, Event: event.Event } });
          const categoriesFromMixedToNormalSubLevel13 =
            categoriesOnResultsSubLevel13.map((cat) =>
              cat.CatCode.replace("X", "M").replace("X", "W")
            );

          const resultsAllCategories = this.wcup_athlete_service.athleteCategoriesCombo.data.filter(option => {
            const category = (option as any).Cat;
            return (
              categoriesResultsGeneralTable.map(cat => cat.CatCode).indexOf(category) > -1 ||
              categoriesResultsGeneralTableMixedToNormal.indexOf(category) > -1
            );
          });
          const resultsAllEvents = this.wcup_athlete_service.eventTypeCombo['extraOptions'].map(option => option.item).filter(event => {
            const eventType = event.Name === "Mixed Team" ? "Mixed" : event.Name;
            return categoriesResultsGeneralTable.map(cat => cat.Event).indexOf(eventType) > -1
          })
          this.wcup_athlete_service.eventTypeCombo.setData(resultsAllEvents as any, resultsAllEvents[0])
          this.wcup_athlete_service.categoriesCombo.setData(resultsAllCategories, resultsAllCategories[0]);
          this.wcup_athlete_service.categoriesReady.next(true);
          const resultsStageTableCategories =
            // Get data from filter.
            this.wcup_athlete_stage_service.athleteCategoriesCombo.data.filter(
              (option) => {
                const category = (option as any).Cat;

                return (
                  categoriesOnResultsSubLevel12.map(cat => cat.CatCode).indexOf(category) > -1 ||
                  categoriesFromMixedToNormalSubLevel12.indexOf(category) > -1
                );
              }
            );

          const resultsStageEvents = [{ Name: 'All', Value: 0 }].concat(this.wcup_athlete_stage_service.eventTypeCombo['extraOptions'].map(option => option.item).filter(event => {
            const eventType = event.Name === "Mixed Team" ? "Mixed" : event.Name;
            return categoriesOnResultsSubLevel12.map(cat => cat.Event).indexOf(eventType) > -1;
          }));

          this.wcup_athlete_stage_service.eventTypeCombo.filterInfo.options.initial_state = true;
          // Select the initial value for the event combo.
          this.wcup_athlete_stage_service.eventTypeCombo.setSelected({ Name: 'Individual', Value: 0 });
          this.wcup_athlete_stage_service.eventTypeCombo.setData(resultsStageEvents as any, resultsStageEvents[1]);
          this.wcup_athlete_stage_service.categoriesCombo.setData(resultsStageTableCategories, resultsStageTableCategories[1])
          this.wcup_athlete_stage_service.categoriesReady.next(true);
          const resultsFinalsTableCategories =
            // Get data from filter.
            this.wcup_athlete_finals_service.athleteCategoriesCombo.data.filter(
              (option) => {
                const category = (option as any).Cat;

                return (
                  categoriesOnResultsSubLevel13.map(cat => cat.CatCode).indexOf(category) > -1 ||
                  categoriesFromMixedToNormalSubLevel13.indexOf(category) > -1
                );
              }
            );
          const resultsFinalsEvents = this.wcup_athlete_finals_service.eventTypeCombo['extraOptions'].map(option => option.item).filter(event => {
            const eventType = event.Name === "Mixed Team" ? "Mixed" : event.Name;
            return categoriesOnResultsSubLevel13.map(cat => cat.Event).indexOf(eventType) > -1
          });
          this.wcup_athlete_finals_service.categoriesCombo.setData(resultsFinalsTableCategories, resultsFinalsTableCategories[0]);
          this.wcup_athlete_finals_service.eventTypeCombo.setData(resultsFinalsEvents as any, resultsFinalsEvents[0])
          this.wcup_athlete_finals_service.categoriesReady.next(true);
          this.$resultsDataProcess.next(Array.from(a.items));
          // In format of Year, Stage 1, Stage 2, Stage 3 Stage 4 Final to be used in the first table.
          const resultsMapped = [];
          const years = forkJoin(
            ...[].concat
              .apply(
                [],
                (a.items as IWCupAthleteItem[]).map((value) => {
                  return value.Details.map((details) => details.Year);
                })
              )
              .map((year) => {

                return this.seriesStageStore
                  .requestData({ Year: year, DisciplineId: "1" }, false)
                  .pipe(
                    tap((yearsStage) => {
                      a.items.forEach((value) => {
                        value["ResultsTransformed"].forEach(
                          (resultTransformed) => {
                            const index = yearsStage.items.findIndex(
                              (yearsStage) => {
                                return (
                                  resultTransformed.ID.toString() ===
                                  yearsStage.ID.toString()
                                );
                              }
                            );
                            if (index > -1) {
                              resultTransformed["StageData"] =
                                yearsStage.items[index];
                              // Perform filter to locate country by code.
                              const countryFind = countryData.find(
                                (country) =>
                                  yearsStage.items[index].Country ===
                                  country.NOC
                              );
                              // IF this one is present.
                              if (countryFind) {
                                // Override the data.
                                resultTransformed["StageData"][
                                  "CountryName"
                                ] = countryFind.CShort;
                              }
                              let indexResultsMappedOnFirstTable =
                                resultsMapped.findIndex(
                                  (result) => result.Year === year
                                );
                              let result = Object.assign(resultTransformed.Results, { 'StageData': resultTransformed["StageData"] });
                              const stage =
                                resultTransformed[
                                  "StageData"
                                ].Stage.toString();

                              if (indexResultsMappedOnFirstTable === -1) {
                                const resultObject = {
                                  Year: year,
                                  Stage_1: [],
                                  Stage_2: [],
                                  Stage_3: [],
                                  Stage_4: [],
                                  Final: [],
                                };
                                resultsMapped.push(resultObject);
                              }
                              indexResultsMappedOnFirstTable =
                                resultsMapped.findIndex(
                                  (result) => result.Year === year
                                );

                              let yearResults = resultsMapped[indexResultsMappedOnFirstTable];
                              switch (stage) {
                                case "1":
                                  this.addEventToStageData(yearResults.Stage_1, result, resultTransformed.Event);
                                  break;
                                case "2":
                                  this.addEventToStageData(yearResults.Stage_2, result, resultTransformed.Event);
                                  break;
                                case "3":
                                  this.addEventToStageData(yearResults.Stage_3, result, resultTransformed.Event);
                                  break;
                                case "4":
                                  this.addEventToStageData(yearResults.Stage_4, result, resultTransformed.Event);
                                  break;
                                case "-1":
                                  this.addEventToStageData(yearResults.Final, result, resultTransformed.Event, true);
                                  break;
                              }
                            }
                          }
                        );
                      });
                    })
                  );
              })
          );
          return combineLatest(of(a), years, of(resultsMapped), this.wcup_athlete_finals_service.getDataStreamWithFilters());
        }),
        map((a) => {
          return a[2];
        })
      )
      .subscribe((next) => {
        //this.$resultsDataProcess.next(next as any);
        //this.resultsDataProcess = next;
        this.$resultsGeneralProcess.next(next)
      })
  }


  /**
   * {@inheritdoc}
   *
   * @memberof BootstrapAthleteWcupRankingComponent
   */
  ngOnInit() {
    this.subscriptions.push(
      this.getSubscription1(),
      this.wireUpWCupSublevelTableData(13, this.wcup_athlete_finals_service, this.$resultsFinal, this.$insightsFinal),
      this.wireUpWCupSublevelTableData(12, this.wcup_athlete_stage_service, this.$resultsStage, this.$insightsStage),
      this.getSubscription4()
    );
  }
}
